export default "__VITE_ASSET__4ad75737__"